var CATEGORIES = 'CATEGORIES';
var FILES = 'FILES';
var LABELS = 'LABELS';
export { CATEGORIES, FILES, LABELS };